import { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
// import { Redirect } from "react-router-dom/cjs/react-router-dom";
import { Editor, EditorState, convertToRaw, convertFromRaw, RichUtils } from "draft-js";
import 'draft-js/dist/Draft.css';
import { addResultHalCompass } from "../../../../stores/actions/resultHalCompassAction";
import { Link, Redirect } from 'react-router-dom'

class Evaluation extends Component {
    state = {
        name: '',
        website: '',
        userId: '',
        phoneNumber: '',
        staffTotal: '',
        operationalHour: '',
        shift: '',
        halalNeeds: [],
        industrialCategory: '',
        selectedScheme: '',
        companyId: '',
        isNewCompany: true,
        pdpaConsent: false,
        dateCreated: '',

        selectedSchemeScope: '',
        selectedAnswers: [],

        newForm: null,
        selectedCompany: null,
        hideBtnStart: false,
        showEvaluationA: false,
        showEvaluationBQuestions: false,
        showEvaluationB: false,
        showAnswerReview: false,
        showSubmissionSuccess: false,
    }


    baseState = this.state;

    componentDidUpdate = (prevProps, prevState) => {
        const { addResultHalCompassError, addResultHalCompassSuccess } = this.props;

        if (prevProps.addResultHalCompassError !== addResultHalCompassError) {
            this.setState({
                message: {
                    msg: addResultHalCompassError.message,
                    type: addResultHalCompassError.type
                }
            })
        }

        if (prevProps.addResultHalCompassSuccess !== addResultHalCompassSuccess) {
            this.setState({
                message: {
                    msg: addResultHalCompassSuccess.message,
                    type: addResultHalCompassSuccess.type
                }
            }, () => this.setState({ ...this.baseState, showSubmissionSuccess: true, showAnswerReview: false }))
        }
    }

    isFormInvalid = () => {
        const { name, website, phoneNumber, staffTotal, operationalHour, shift, halalNeeds, industrialCategory, selectedScheme } = this.state;

        return (
            !name.trim() || !website.trim() || !phoneNumber.trim() || !staffTotal.trim() || !operationalHour.trim() || !shift || halalNeeds.length === 0 || !industrialCategory.trim() || !selectedScheme
        )
    }

    scrollWindowToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    handleCategoryChange = (event) => {
        this.setState({ industrialCategory: event.target.value })
    }

    startQuestion = () => {

        this.setState({
            hideBtnStart: true,
            // showEvaluationA: true
        });
    }

    onSelectSchemeSchopeChange = (event) => {
        this.setState({ selectedSchemeScope: event.target.value, showEvaluationBQuestions: true });
    }

    startEvaluationB = () => {
        const { userId } = this.state;
        const { auth } = this.props;
        this.scrollWindowToTop();

        if (!userId) {
            this.setState({
                userId: auth.uid,
                showEvaluationA: false,
                showEvaluationB: true,

            })
        } else {
            this.setState({
                showEvaluationA: false,
                showEvaluationB: true
            })
        }

    }

    previousPage = () => {
        this.scrollWindowToTop();
        this.setState({
            selectedAnswers: [],
            showEvaluationA: true,
            showEvaluationB: false
        })
    }

    backToEvaluation = () => {
        this.scrollWindowToTop();
        this.setState({
            showAnswerReview: false,
            showEvaluationB: true
        })
    }

    handleSchemeChange = (event) => {
        const { schemes } = this.props;
        const value = event.target.value;
        const schemeObject = schemes.find(s => s.id === value);
        const filteredScheme = (({ id, name, code }) => ({ id, name, code }))(schemeObject);

        this.setState({ selectedScheme: filteredScheme });
        if (this.props.onSelectedSchemesChange) {
            this.props.onSelectedSchemesChange(filteredScheme);
        }
    }

    handleHalalNeed = (event) => {
        const data = event.target.value;
        const isChecked = event.target.checked;

        this.setState((prevState) => {
            if (isChecked) {
                return {
                    halalNeeds: [...prevState.halalNeeds, data]
                };
            } else {
                return {
                    halalNeeds: prevState.halalNeeds.filter(item => item !== data)
                }
            }
        })
    }

    handleCompanySelection = (event) => {
        const selectedValue = event.target.value;

        if (selectedValue === "new") {
            this.setState({
                name: '',
                website: '',
                userId: '',
                phoneNumber: '',
                staffTotal: '',
                operationalHour: '',
                shift: '',
                halalNeeds: [],
                industrialCategory: '',
                selectedScheme: '',
                companyId: '',
                newForm: true,
                isNewCompany: true,

                selectedCompany: null,
                hideBtnStart: true,
                showEvaluationA: true,
                showEvaluationB: false,
                showSchemeScopeSelect: false


            });
        } else if (selectedValue) {

            const { companyProfile } = this.props;
            const selectedCompany = companyProfile.find(company => company.id === selectedValue);
            if (selectedCompany) {
                this.setState({
                    selectedCompany: selectedCompany,
                    name: selectedCompany.name || '',
                    website: selectedCompany.website || '',
                    userId: selectedCompany.userId || '',
                    phoneNumber: selectedCompany.phoneNumber || '',
                    staffTotal: selectedCompany.staffTotal || '',
                    operationalHour: selectedCompany.operationalHour || '',
                    shift: selectedCompany.shift || '',
                    halalNeeds: selectedCompany.halalNeeds || [],
                    industrialCategory: selectedCompany.industrialCategory || '',
                    selectedScheme: selectedCompany.selectedSchemes || '',
                    companyId: selectedCompany.id,
                    isNewCompany: false,

                    newForm: false,
                    hideBtnStart: true,
                    showEvaluationA: true,
                    showEvaluationB: false,
                    showSchemeScopeSelect: false
                });
            }
        } else {
            this.setState({
                isNewCompany: null,
                selectedCompany: null,
                hideBtnStart: true,
                showEvaluationA: false,
                showEvaluationB: false,
                showSchemeScopeSelect: false
            });
        }
    }


    loadIntroEvaluation = () => {

        const { companyProfile } = this.props;
        const { showEvaluationA, showEvaluationB, showAnswerReview, hideBtnStart } = this.state;


        return (
            <div className="text-left">
                <div hidden={showAnswerReview}>
                    <label htmlFor="companySelect" /> Select Company:
                    <select
                        className="form-control"
                        name="companySelect"
                        id="companySelect"
                        onChange={this.handleCompanySelection}
                        defaultValue=""
                        disabled={!(!showEvaluationB && !showAnswerReview)} hidden={showAnswerReview}>
                        <option value="">Select managed company or start new</option>
                        <option value="new">Start with new company</option>
                        {companyProfile && companyProfile.map(uCompany => {
                            return (
                                <>
                                    <option key={uCompany.id} value={uCompany.id}>{uCompany.name}</option>
                                </>
                            )
                        })}
                    </select>
                </div>
            </div>
        )
    }


    loadEvaluationA = () => {
        const { schemes } = this.props;

        const { name, website, phoneNumber, staffTotal, operationalHour, shift, selectedScheme, halalNeeds, industrialCategory } = this.state;


        return (
            <div className="text-left">
                <h3 className="text-center"><b>Evaluation A</b></h3>
                <div className="mb-3">
                    <label htmlFor="" /> Nama Syarikat:
                    <input className="form-control" type="text" value={name} onChange={event => this.setState({ name: event.target.value })} placeholder="Company's Name" />
                </div>
                <div className="mb-3">
                    <label htmlFor="" /> Laman Sesawang Syarikat:
                    <input className="form-control" type="text" value={website} onChange={event => this.setState({ website: event.target.value })} placeholder="Company's Website" />
                </div>
                <div className="mb-3">
                    <label htmlFor="" /> Nombor Telefon Syarikat:
                    <input className="form-control" type="text" value={phoneNumber} onChange={event => this.setState({ phoneNumber: event.target.value })} placeholder="Company Phone Number" />
                </div>
                <div className="mb-3">
                    <label htmlFor="" /> Bilangan Pekerja:
                    <select className="form-control" value={staffTotal} onChange={event => this.setState({ staffTotal: event.target.value })}>
                        <option value="">Choose Worker Amount Range</option>
                        <option value={'1 - 50 ORANG'}>1 - 50 ORANG</option>
                        <option value={'50 - 100 ORANG'}>50 - 100 ORANG</option>
                        <option value={'100 - 500 ORANG'}>100 - 500 ORANG</option>
                        <option value={'500 DAN KE ATAS'}>500 DAN KE ATAS</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label htmlFor="" /> Masa Operasi:
                    <input className="form-control" type="text" value={operationalHour} onChange={event => this.setState({ operationalHour: event.target.value })} placeholder="Operation Time" />
                </div>

                <div className="mb-3">
                    <label htmlFor="" /> Bilangan Shif:
                    <select className="form-control " value={shift} onChange={event => this.setState({ shift: event.target.value })}>
                        <option value="">Choose shift amount</option>
                        <option value={'1'}>1 SHIFTS</option>
                        <option value={'2'}>2 SHIFTS</option>
                        <option value={'3'}>3 SHIFTS</option>
                        <option value={'4'}>4 SHIFTS</option>
                        <option value={'5+'}>5 SHIFTS DAN KE ATAS</option>
                    </select>
                </div>


                <div className="my-3">
                    <label htmlFor="" />Keperluan Perniagaan Untuk Pensijilan Halal
                    <div className="mb-1"><em><small>Sila tandakan jawapan yang relevan atau paling hampir dengan keperluan dan keadaan perniagaan anda</small></em></div>
                    <div className="d-flex flex-column align-items-start pl-3">
                        <div className="mb-1"><input type="checkbox" value={'PERMINTAAN PASARAN DAN KEPERCAYAAN PENGGUNA'} checked={halalNeeds.some(item => item.toUpperCase() === 'PERMINTAAN PASARAN DAN KEPERCAYAAN PENGGUNA')} onChange={this.handleHalalNeed} /> PERMINTAAN PASARAN DAN KEPERCAYAAN PENGGUNA</div>
                        <div className="mb-1"><input type="checkbox" value={'PENGEMBANGAN PASARAN - TEMPATAN DAN ANTARABANGSA'} checked={halalNeeds.some(item => item.toUpperCase() === 'PENGEMBANGAN PASARAN - TEMPATAN DAN ANTARABANGSA')} onChange={this.handleHalalNeed} /> PENGEMBANGAN PASARAN - TEMPATAN DAN ANTARABANGSA</div>
                        <div className="mb-1"><input type="checkbox" value={'PENJENAMAAN DAN KEUNGGULAN DAYA SAING'} checked={halalNeeds.some(item => item.toUpperCase() === 'PENJENAMAAN DAN KEUNGGULAN DAYA SAING')} onChange={this.handleHalalNeed} /> PENJENAMAAN DAN KEUNGGULAN DAYA SAING</div>
                        <div className="mb-1"><input type="checkbox" value={'KEPERLUAN B2B DAN INTEGRASI RANTAIAN BEKALAN'} checked={halalNeeds.some(item => item.toUpperCase() === 'KEPERLUAN B2B DAN INTEGRASI RANTAIAN BEKALAN')} onChange={this.handleHalalNeed} /> KEPERLUAN B2B DAN INTEGRASI RANTAIAN BEKALAN</div>
                        <div className="mb-1"><input type="checkbox" value={'PEMATUHAN KEPADA PERATURAN ATAU KEPERLUAN TENDER'} checked={halalNeeds.some(item => item.toUpperCase() === 'PEMATUHAN KEPADA PERATURAN ATAU KEPERLUAN TENDER')} onChange={this.handleHalalNeed} /> PEMATUHAN KEPADA PERATURAN ATAU KEPERLUAN TENDER</div>
                        <div className="mb-1"><input type="checkbox" value={'MEMBEZAKAN PRODUK DAN PENETAPAN HARGA PREMIUM'} checked={halalNeeds.some(item => item.toUpperCase() === 'MEMBEZAKAN PRODUK DAN PENETAPAN HARGA PREMIUM')} onChange={this.handleHalalNeed} /> MEMBEZAKAN PRODUK DAN PENETAPAN HARGA PREMIUM</div>
                        <div className="mb-1"><input type="checkbox" value={'PENGURUSAN RISIKO DAN PENCEGAHAN KRISIS'} checked={halalNeeds.some(item => item.toUpperCase() === 'PENGURUSAN RISIKO DAN PENCEGAHAN KRISIS')} onChange={this.handleHalalNeed} /> PENGURUSAN RISIKO DAN PENCEGAHAN KRISIS</div>
                        <div className="mb-1"><input type="checkbox" value={'PENINGKATAN KEYAKINAN PELABUR DAN RAKAN STRATEGIK'} checked={halalNeeds.some(item => item.toUpperCase() === 'PENINGKATAN KEYAKINAN PELABUR DAN RAKAN STRATEGIK')} onChange={this.handleHalalNeed} /> PENINGKATAN KEYAKINAN PELABUR DAN RAKAN STRATEGIK</div>
                        <div className="mb-1"><input type="checkbox" value={'PEMATUHAN KEPADA POLISI DALAMAN SYARIKAT'} checked={halalNeeds.some(item => item.toUpperCase() === 'PEMATUHAN KEPADA POLISI DALAMAN SYARIKAT')} onChange={this.handleHalalNeed} /> PEMATUHAN KEPADA POLISI DALAMAN SYARIKAT</div>
                        <div className="mb-1"><input type="checkbox" value={'SOKONGAN KEPADA TANGGUNGJAWAB SOSIAL KORPORAT (CSR)'} checked={halalNeeds.some(item => item.toUpperCase() === 'SOKONGAN KEPADA TANGGUNGJAWAB SOSIAL KORPORAT (CSR)')} onChange={this.handleHalalNeed} /> SOKONGAN KEPADA TANGGUNGJAWAB SOSIAL KORPORAT (CSR)</div>
                    </div>
                </div>
                <div className="my-3">
                    <label />Kategori Industri
                    <div className="d-flex flex-column pl-3">
                        <div className="mb-1"><input type="radio" name="kategori" value={"BESAR (Perolehan melebihi RM50,000,000.00)"} checked={industrialCategory === "BESAR (Perolehan melebihi RM50,000,000.00)"} onChange={(event) => this.handleCategoryChange(event)} /> BESAR (Perolehan melebihi RM 50,000,000.00)</div>
                        <div className="mb-1"><input type="radio" name="kategori" value={"SEDERHANA (Perolehan antara RM15,000,000.00 hingga RM50,000,000.00)"} checked={industrialCategory === "SEDERHANA (Perolehan antara RM15,000,000.00 hingga RM50,000,000.00)"} onChange={(event) => this.handleCategoryChange(event)} /> SEDERHANA (Perolehan antara RM 15,000,000.00 hingga RM 50,000,000.00)</div>
                        <div className="mb-1"><input type="radio" name="kategori" value={"KECIL (Perolehan antara RM300,000 hingga kurang daripada RM14,999,999.99)"} checked={industrialCategory === "KECIL (Perolehan antara RM300,000 hingga kurang daripada RM14,999,999.99)"} onChange={(event) => this.handleCategoryChange(event)} /> KECIL (Perolehan antara RM 300,000 hingga kurang daripada RM 14,999,999.99)</div>
                        <div className="mb-1"><input type="radio" name="kategori" value={"MIKRO (Perolehan kurang daripada RM300,000.00)"} checked={industrialCategory === "MIKRO (Perolehan kurang daripada RM300,000.00)"} onChange={(event) => this.handleCategoryChange(event)} /> MIKRO (Perolehan kurang daripada RM 300,000.00)</div>
                    </div>
                </div>
                <div>
                    <label />Skim Pensijilan
                    {schemes && schemes.map(scheme => {
                        return (
                            <div key={scheme.id} className="pl-3">
                                <input name="criteria" checked={selectedScheme.id === scheme.id} type="radio" value={scheme.id} onChange={this.handleSchemeChange} /> {scheme.name}</div>
                        )
                    })}
                </div>

                <div className="d-flex justify-content-end">
                    <button className="btn all-btn" disabled={this.isFormInvalid()} onClick={this.startEvaluationB}>Go To Evaluation B</button>
                </div>
            </div>
        )
    }

    loadEvaluationB = () => {

        const { name, showEvaluationA, showEvaluationB, newForm, showAnswerReview, selectedAnswers, selectedScheme, showEvaluationBQuestions, selectedSchemeScope } = this.state;
        const { evaluationB, schemes } = this.props; // Already filtered by Firestore query!

        const totalQuestions = evaluationB?.length || 0;// get total questions
        const totalSelectedAnswers = selectedAnswers?.reduce((total, criteriaObj) => { //get total answers of the questions including from each criteria
            return total + (criteriaObj.answers?.length || 0);
        }, 0) || 0;
        const selectedSchemeScopes = schemes.filter(scheme => scheme.id === selectedScheme.id)

        // console.log('schemes', schemes);
        // console.log('selectedScheme', selectedScheme)
        // console.log('selectedSchemeScope', selectedSchemeScope);
        return (
            <div className="text-left">
                <h3 className="text-center"><b>Evaluation B</b></h3>
                {newForm ? (
                    <div className="mb-3">
                        <label /> Nama Syarikat:
                        <input className="form-control" type="text" value={name} disabled={!showEvaluationA && showEvaluationB} />
                    </div>
                ) : (
                    <div></div>
                )}

                <div className="mt-4">
                    <h4>HalcomPASS Evaluation : {selectedScheme.name}</h4>
                    <div className="mb-3 border p-3" style={{ backgroundColor: '#dee2e6' }}>
                        <p><strong>Select Scope Related to Selected Scheme</strong></p>
                        <div className="mb-3 border p-3" style={{ backgroundColor: '#f7fafc' }}>
                            <div className="mb-2 ml-3">
                                {selectedSchemeScopes ?
                                    selectedSchemeScopes.flatMap((schemeScope, schemeScopeIndex) =>
                                        schemeScope.activities.map((activity, activityIndex) => (
                                            <div key={`${schemeScopeIndex}-${activityIndex}`} className="mb-2">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="schemeScope"
                                                        checked={selectedSchemeScope === activity}
                                                        value={activity}
                                                        onChange={this.onSelectSchemeSchopeChange}
                                                    />
                                                    {' '}{activity}
                                                </label>
                                            </div>
                                        ))
                                    )
                                    : <p>No scope available</p>
                                }
                            </div>
                        </div>
                    </div>
                    {showEvaluationBQuestions && evaluationB && evaluationB.length > 0 ? (
                        (() => {
                            //define the order of the criteria
                            const criteriaOrder = [
                                "Profil Syarikat",
                                "Pekerja",
                                "Sumber Bahan",
                                "Ketersediaan Produk",
                                "Dokumentasi Lain-lain"
                            ];

                            const groupedEvaluation = evaluationB.reduce((grouped, evaB) => {//grouped: accumulator(start with empty object as mentioned in second argument:{}); evaB: things to be added into accumulator
                                const criteriaName = evaB.selectedCriteria?.name || 'No Criteria';

                                if (!grouped[criteriaName]) {//if criteriaName doesn't exists, create new criteria with an empty array
                                    grouped[criteriaName] = [];// this creates grouped = {"Criteria Name:[]"}
                                }
                                grouped[criteriaName].push(evaB);//if said criteria exists, push evaB inside the accumulator
                                return grouped;

                            }, {});

                            return criteriaOrder.map(criteriaName => {
                                const evaluations = groupedEvaluation[criteriaName];
                                if (!evaluations || evaluations.length === 0) return null;

                                return (
                                    <div key={criteriaName} className="mb-3 border p-2" style={{ backgroundColor: '#dee2e6' }}>
                                        <p><strong>Kriteria: {criteriaName}</strong></p>
                                        {evaluations.map((evaB, evalIndex) => {
                                            // console.log('evaluations:', evaluations);
                                            // console.log('evaB:', evaB);
                                            return (
                                                <div key={evalIndex} className="mb-3 border p-3" style={{ backgroundColor: '#f7fafc' }}>
                                                    <div><span>{evalIndex + 1}</span>{'. '}{evaB.question}</div>

                                                    {evaB?.descriptions?.blocks?.some(block => block.text !== "") && (
                                                        <div className="p-3 mb-2 border bg-white">
                                                            <Editor
                                                                editorState={EditorState.createWithContent(convertFromRaw(evaB.descriptions))}
                                                                readOnly={true}
                                                                onChange={() => { }} // Required prop, but does nothing since readOnly is true
                                                            />
                                                        </div>
                                                    )}
                                                    {evaB.answers && evaB.answers.map((answer, answerIndex) => {
                                                        const answerData = {
                                                            questionId: evaB.id,
                                                            question: evaB.question,
                                                            score: answer.score,
                                                            answer: answer.text,
                                                            reference: answer.reference,
                                                            review: answer.review,
                                                            status: answer.status,
                                                            description: evaB.descriptions !== undefined ? evaB.descriptions : {}
                                                        }
                                                        return (
                                                            <div key={answerIndex} className="mb-2 ml-3">
                                                                <input type="radio" name={evaB.id} value={answerIndex} checked={this.state.selectedAnswers
                                                                    ?.find(criteriaObj => criteriaObj.criteria === criteriaName)
                                                                    ?.answers?.some(selected => selected.questionId === evaB.id && selected.answer === answer.text
                                                                    ) || false} className="mr-2" onChange={() => this.handleUserEvaluation(answerData, criteriaName)} />
                                                                {answer.text}
                                                            </div>)
                                                    })}
                                                </div>)
                                        })}
                                    </div>
                                );
                            }).filter(Boolean)
                        })()
                    ) : (<div>Select Related Scheme Scope First</div>)}
                </div>


                <div className="d-flex justify-content-between">{/* disable button kalau answer tak sama dengan total questions */}
                    <button className="btn all-btn" onClick={this.previousPage}>Back</button>
                    <button className="btn all-btn " disabled={totalSelectedAnswers !== totalQuestions} onClick={() => {
                        this.setState({ showAnswerReview: !showAnswerReview, showEvaluationB: !showEvaluationB });
                        this.scrollWindowToTop()
                    }}>Next</button>
                </div>
            </div>
        )
    }

    loadAnswerReview = () => {
        // this.scrollWindowToTop();
        const { selectedAnswers, name, website, phoneNumber, staffTotal, operationalHour, shift, industrialCategory, halalNeeds, pdpaConsent, selectedScheme, selectedSchemeScope } = this.state;
        return (
            <div>
                <h2><b>Review your answers</b></h2>
                <div ><h3 className="text-left">Evaluation A</h3></div>
                {name ? (
                    <div className="d-flex justify-content-center text-left" >

                        <table className="table text-left border">
                            <tr>
                                <td>Nama Syarikat </td>
                                <td>: {name}</td>
                            </tr>
                            <tr>
                                <td>Laman Sesawang Syarikat </td>
                                <td>: {website}</td>
                            </tr>
                            <tr>
                                <td>Nombor Telefon Syarikat </td>
                                <td>: {phoneNumber}</td>
                            </tr>
                            <tr>
                                <td>Bilangan Pekerja </td>
                                <td>: {staffTotal}</td>
                            </tr>
                            <tr>
                                <td>Masa Operasi </td>
                                <td>: {operationalHour}</td>
                            </tr>
                            <tr>
                                <td>Bilangan Shif </td>
                                <td>: {shift}</td>
                            </tr>
                            <tr>
                                <td>Kategori Industri </td>
                                <td>: {industrialCategory}</td>
                            </tr>
                            <tr>
                                <td>Keperluan Halal </td>
                                <td>
                                    {halalNeeds.map((certNeeds, certIndex) =>
                                        <li key={certIndex}> {certNeeds}</li>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Skim</td>
                                <td>: {selectedScheme.name}</td>
                            </tr>
                            <tr>
                                <td>Skop Skim</td>
                                <td>: {selectedSchemeScope}</td>
                            </tr>
                        </table>


                    </div>
                ) : (<div>No Related Company</div>)}
                <div ><h3 className="text-left">Evaluation B</h3></div>
                {selectedAnswers && selectedAnswers.map((selectedAnswer, answerIndex) => {
                    return (
                        <div className="text-left border p-3 mb-2" style={{ backgroundColor: '#dee2e6' }} key={answerIndex}>
                            <h5>Criteria: {selectedAnswer.criteria}</h5>
                            {selectedAnswer.answers.map((answerList, answerListIndex) =>
                                <div className="d-flex text-left align-items-center border bg-white" key={answerList.questionId}>

                                    <table className="table mb-0">
                                        <tr>
                                            <td className="border-right col-md-1 align-middle">{answerListIndex + 1}</td>
                                            <td className="text-left col-md-11">
                                                <div>Question: {answerList.question}</div>
                                                <div>Answer: {answerList.answer}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            )}
                        </div>
                    )
                })}
                <div className="d-flex justify-content-start align-items-center">
                    <div className="d-flex">
                        <input type="checkbox" onChange={() => this.setState({ pdpaConsent: !pdpaConsent })} />
                    </div>
                    <div className="text-left p-1" style={{ fontSize: 'smaller' }}>
                        By clicking this box I consent to the given information being used by Halal Academy for data processing
                    </div>
                </div>
                <div className="d-flex justify-content-between ">
                    <button className="btn all-btn" onClick={this.backToEvaluation}>Back</button>
                    <button className="btn all-btn" disabled={!pdpaConsent} onClick={this.addEvaluation}>Submit</button>
                </div>
            </div>
        )
    }

    loadSubmissionSuccess = () => {

        return (
            <div className="d-flex justify-content-center flex-column align-items-center" style={{ height: '50vh' }}>
                <div>
                    <span style={{ color: 'green' }}>
                        <i className="fa fa-check fa-5x"></i>
                    </span>
                </div>
                <div>
                    <h3>Your Submission Is Successful!!</h3>
                    <div>We have received your submission</div>
                </div>
                <Link to="/"><button className="btn all-btn" >Go to Homepage</button>{/* Nanti buat function pergi dekat page list of reports */}</Link>
            </div>
        )
    }

    handleUserEvaluation = (selectedAnswerData, selectedCriteriaName) => {
        this.setState(prevState => {
            const hasCriteria = prevState.selectedAnswers.some(answer =>
                answer.criteria === selectedCriteriaName
            )
            if (!hasCriteria) {//if criteria not exists, add new criteria
                return {
                    selectedAnswers: [
                        ...prevState.selectedAnswers,
                        {
                            criteria: selectedCriteriaName,
                            answers: [selectedAnswerData]
                        }
                    ]
                }
            } else {//if criteria exists..
                const updatedAnswers = prevState.selectedAnswers.map(criteriaObj => {
                    if (criteriaObj.criteria === selectedCriteriaName) {//if prevState have the same criteria with the selected one
                        const filteredAnswers = criteriaObj.answers.filter(//check if answers exists
                            ans => ans.questionId !== selectedAnswerData.questionId
                        );
                        return {//if exists, update the answer array
                            criteria: selectedCriteriaName,
                            answers: [...filteredAnswers, selectedAnswerData]
                        };
                    }
                    return criteriaObj;//if not, return prevState
                });
                return {
                    selectedAnswers: updatedAnswers
                }
            }

        });
    }

    handleDateCreated = () => {
        const date = new Date();
        const createdAt = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'Asia/Singapore'
        }) + ' at ' + date.toLocaleTimeString('en-GB', {
            hour12: false,
            timeZone: 'Asia/Singapore'
        }) + ' UTC+8';

        this.setState({ dateCreated: createdAt });
        return createdAt
    }

    addEvaluation = () => {
        const dateCreated = this.handleDateCreated();

        const {
            name,
            website,
            userId,
            phoneNumber,
            staffTotal,
            operationalHour,
            shift,
            halalNeeds,
            industrialCategory,
            selectedScheme,
            isNewCompany,
            selectedAnswers,
            companyId,
            pdpaConsent,
            selectedSchemeScope
        } = this.state;


        const resultHalCompass = {
            companyProfile: {
                name,
                website,
                phoneNumber,
                staffTotal,
                operationalHour,
                shift,
                halalNeeds,
                industrialCategory,
                companyId: !isNewCompany ? companyId : ''
            },
            isNewCompany,
            pdpaConsent,
            selectedAnswers,
            selectedScheme,
            userId,
            dateCreated,
            selectedSchemeScope
        }


        this.props.addResultHalCompass(resultHalCompass);

    }

    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to="/" />


        return (
            <div className="page-learning learning min-height">
                <div className="page-header middle">
                    <b>HalComPASS Evaluation</b>
                    <div className="title-border"></div>
                </div>

                <div className="page-content">
                    <div className="middle">
                        <div className="text-center col-md-8">
                            <div hidden={this.state.hideBtnStart || this.state.showSubmissionSuccess}>
                                <div className="alert alert-warning text-left" style={{ margin: "0px 0px 40px 0px" }}>
                                    <div className="listing">
                                        <div><b>Selamat Datang ke Penilaian Kesediaan Halal <span>&#40;<em>Halal Readiness Assessment</em>&#41;</span></b></div><br />
                                        <div>Terima kasih kerana sudi meluangkan masa untuk menyertai penilaian ini. Soal selidik ini direka untuk membantu syarikat mengenal pasti
                                            tahap kesediaan dalam memenuhi keperluan pensijilan halal melalui penilaian kendiri
                                        </div>
                                        <br />
                                        <div><span><i className="fa fa-clock position-static"></i></span><b>  Soal Selidik ini akan mengambil masa kira-kira 10 hingga 15 minit</b></div><br />
                                        <div><b>Maklumat Penting</b></div>
                                        <div>Penilaian ini <b>bukan merupakan permohonan rasmi</b> untuk mendapatkan <b>Sijil Pengesahan Halal Malaysia &#40;SPHM&#41;</b></div><br />
                                        <div><b>Struktur Soal Selidik</b>
                                            <p>Soal Selidik ini terdiri daripada <b>dua bahagian :</b></p>
                                            <div style={{ position: 'relative', left: '30px' }}>
                                                <li><b>Bahagian A</b> - Profil Syarikat</li>
                                                <li><b>Bahagian B</b> - Penilaian Kesediaan Halal</li>
                                            </div>
                                        </div><br />
                                        <div>Sila jawab semua soalan dengan jujur dan lengkap bagi mendapatkan gambaran sebenar tahap kesediaan syarikat anda.</div>
                                    </div>
                                    <button className="btn all-btn" onClick={this.startQuestion}>Start Company Evaluation {' '} <i className="fas fa-arrow-alt-circle-right"></i></button>

                                </div>
                            </div>
                            {/* Always show company selection dropdown when evaluation has started */}
                            {this.state.hideBtnStart && this.loadIntroEvaluation()}

                            {/* Show evaluation A form when showEvaluationA is true */}
                            {this.state.showEvaluationA && this.loadEvaluationA()}

                            {/* Show evaluation B when showEvaluationB is true */}
                            {this.state.showEvaluationB && this.loadEvaluationB()}

                            {/* Show answer review when showAnswerReview is true*/}
                            {this.state.showAnswerReview && this.loadAnswerReview()}

                            {/* Show submission success page when showSubmissionSuccess is true*/}
                            {this.state.showSubmissionSuccess && this.loadSubmissionSuccess()}

                            <div className="text-left mt-5">

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,

        schemes: state.firestore.ordered.schemes,
        companyProfile: state.firestore.ordered.companyProfile,
        evaluationB: state.firestore.ordered.evaluationB,
        criteria: state.firestore.ordered.criteria,

        addResultHalCompassSuccess: state.resultHalCompass.addResultHalCompassSuccess,
        addResultHalCompassError: state.resultHalCompass.addResultHalCompassError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addResultHalCompass: (resultHalCompass) => dispatch(addResultHalCompass(resultHalCompass)),
    }
}

const ConnectedEvaluation = compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect(props => {
        const queries = [
            { collection: 'schemes' },
            { collection: 'criteria', orderBy: ['indexKey', 'asc'] },
            { collection: 'companyProfile', where: ['userId', '==', props.auth.uid] },
        ];

        if (props.selectedSchemesForQuery) {
            queries.push({
                collection: 'evaluationB', where: ['selectedSchemes', 'array-contains', props.selectedSchemesForQuery], orderBy: ['createdDate', 'asc']
            });
        } else {
            queries.push({ collection: 'evaluationB', limit: 10 });
        }
        return queries;
    })
)(Evaluation);


class EvaluationContainer extends Component {
    state = {
        selectedSchemesForQuery: null
    }

    handleSelectedSchemesChange = (selectedSchemes) => {
        this.setState({ selectedSchemesForQuery: selectedSchemes });
    }

    render() {

        return (
            <ConnectedEvaluation {...this.props} selectedSchemesForQuery={this.state.selectedSchemesForQuery} onSelectedSchemesChange={this.handleSelectedSchemesChange} />
        );
    }
}

export default EvaluationContainer;
